import { IoIosArrowForward } from 'react-icons/io';
import Button from '../../components/kit/button/Button';
import Card from '../../components/kit/card/Card';
import StatelessCard from '../../components/kit/card/StatelessCard';
import Header from '../../components/ui/header/Header';
import DoctorAppointmentCard from '../../components/ui/doctor-appointment-card/DoctorAppointmentCard';
import VyduraReminderCard from '../../components/ui/vydura-reminder-card/VyduraReminderCard';
import { useAppContext } from 'src/app/state';
import styles from './HomePage.module.css';
import Footer from 'src/app/components/ui/footer/Footer';
import { useMemo } from 'react';

const HomePage = () => {
  const {
    state: {
      doctorAppointment,
      vyduraReminder,
      migraineAttacks,
      vyduraSchedule,
    },
  } = useAppContext();
  const vyduraPreventiveDays = useMemo(
    () =>
      migraineAttacks.filter(
        (record) => record.vyduraEveryOtherDay && !record.isMigraineDay
      ),
    [migraineAttacks]
  );
  const onNavigateToVyduraTreatment = () =>
    window.open(
      'https://www.pfizer.co.uk/products/prescription-medicines/vydura',
      '_blank'
    );

  return (
    <>
      <Header />
      <div className={styles.main}>
        <VyduraReminderCard
          reminder={vyduraReminder}
          vyduraPreventiveDays={vyduraPreventiveDays}
          vyduraSchedule={vyduraSchedule}
        />
        <DoctorAppointmentCard scheduledAppointment={doctorAppointment} />
        <Card
          title='My Vydura treatment'
          onCardClick={onNavigateToVyduraTreatment}
        >
          <StatelessCard
            text='How it works, how to take and more'
            imageSource='images/medication.svg'
            Button={
              <Button
                type='transparent'
                width='content-width'
                onClick={onNavigateToVyduraTreatment}
                style={{
                  fontWeight: 500,
                  padding: 0,
                  height: 'fit-content',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Learn more&nbsp;&nbsp;
                <IoIosArrowForward />
              </Button>
            }
          />
        </Card>
      </div>
      <Footer />
    </>
  );
};

export default HomePage;
